import { LenderUser } from 'app/models/dto/lender-user.model';
import { INavTab } from './models/nav-tab.interface';

// Single source of truth for the desktop navbar and the header menu shown below lg.
export const PIPELINE_TABS: INavTab[] = [
  {
    key: 'today',
    text: 'Today',
    uri: '/today',
    permission: 'canViewTodayTab',
  },
  {
    key: 'inventory',
    text: 'Inventory',
    uri: 'sales-inventory',
    permission: 'salesInventoryTracker.read'
  },
  {
    key: 'tasks',
    text: 'Inbox',
    uri: '/',
    uriRegex: '^/$',
  },
  {
    key: 'businesses',
    text: 'Businesses',
    uri: '/list',
  },
  {
    key: 'priority',
    text: 'Priority',
    uri: '/priority',
    permission: 'canViewPriorityTab',
  },
  {
    key: 'funnel',
    text: 'Funnel',
    uri: '/funnel',
  },
  {
    key: 'deals',
    text: 'Deals',
    uri: '/deals',
    permission: 'viewTeamDeals',
  },
  {
    key: 'pulse',
    text: 'Pulse',
    uri: '/pulse',
    permission: 'viewPulseTab',
  },
  {
    key: 'performance',
    text: 'Performance',
    uri: '/performance',
    permission: 'featureNewPerformance',
  },
  {
    key: 'performance-cx',
    text: 'CS Performance',
    uri: '/cx-performance',
    permission: 'viewCXPerformanceTab',
  },
  {
    key: 'bulk-submission',
    text: 'Bulk Submission',
    uri: '/admin/bulk-submission',
    permission: 'canBulkSubmitBorrowersViaLenderApi',
  },
];

export function tabVisibleToUser(user: LenderUser): (tab: INavTab) => boolean {
  return (tab) => {
    if (tab.disableViewFor) {
      if (user?.permissions?.includes(tab.disableViewFor)) {
        return false;
      }
    }

    // HIDE AND SNEAK FOR GLOBAL ACTIVITIES
    if (
      !user?.permissions?.includes('showActivitesTab') &&
      tab.key === 'activity'
    ) {
      return false;
    }

    // HIDE AND SNEAK FOR INBOX
    if (
      tab.key === 'tasks' &&
      user?.permissions?.includes('hideLegacyInbox')
    ) {
      return false;
    }

    //NULL-SAFE CHECK FOR EITHER PERMISSION
    if (tab.key === 'deals') {
      return tab.permission
        ? user?.permissions?.includes('viewFMTeamDeals') ||
            user?.permissions?.includes(tab.permission)
        : user?.permissions?.includes('viewFMTeamDeals');
    }

    if (!tab.permission) {
      return true;
    }
    return user?.permissions?.includes(tab.permission);
  };
}
